import {
  MetricCard,
  MetricsInfoPopover,
  NewMetricCard,
  PlatformMetrics as PlatformMetricsType,
} from '~/components/CreatorChannelMetrics';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

import { usePlatformAnalyticsStore } from './usePlatformAnalyticsStore';

interface Props {
  metricsToShow: PlatformMetricsType[];
  isLoading?: boolean;
}

const MetricsSkeleton = () => (
  <div className="flex flex-col gap-2">
    <div className="h-4 w-40 rounded-4 bg-neutral-50" />
    <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-4">
      {[1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className="flex items-center justify-between rounded-12 border border-neutral-50 bg-card-background-color-default p-6"
        >
          <div className="flex flex-col gap-3">
            <div className="h-3 w-32 rounded-4 bg-neutral-50" />
            <div className="h-10 w-20 rounded-4 bg-neutral-50" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const PlatformMetrics = ({ metricsToShow, isLoading }: Props) => {
  const { platform, selectedMetrics, setSelectedMetrics } =
    usePlatformAnalyticsStore();

  const isMetricsCardsEnabled = useFeature(
    FEATURE_FLAGS.foamMetricsCards,
  ).isEnabled;

  if (isLoading) {
    return <MetricsSkeleton />;
  }

  if (!platform) return null;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <p className="text-16 font-500">Talent & Channel Metrics</p>
        <MetricsInfoPopover
          platform={platform}
          placement="right-start"
          flip={false}
        />
      </div>
      <div className="grid grid-cols-3 gap-4 overflow-visible p-1">
        {metricsToShow.map((metric) =>
          isMetricsCardsEnabled ? (
            <NewMetricCard
              key={metric.title}
              metricTitle={metric.title}
              metricSubtitle={metric.subtitle}
              metricValue={metric.value}
              metricTransformValue={metric.transformValue}
              isChecked={selectedMetrics.includes(metric.title)}
              onChange={() => setSelectedMetrics(metric.title)}
            />
          ) : (
            <MetricCard
              key={metric.title}
              metricTitle={metric.title}
              metricValue={metric.value}
              metricTransformValue={metric.transformValue}
              isChecked={selectedMetrics.includes(metric.title)}
              onChange={() => setSelectedMetrics(metric.title)}
            />
          ),
        )}
      </div>
    </div>
  );
};
